import Main from '@/views/administracion/tableroExpedientes/Main.vue';
import Default from '@/views/administracion/tableroExpedientes/Default.vue';
import DefaultDetalle from '@/views/administracion/tableroExpedientes/detalle/Default.vue';

const auth = ['TableroExpedientes:ver'];
const scopes = ['TableroExpedientes:ver'];

const tableroExpedientes = [
  {
    path: 'tablero-expedientes',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'tableroExpedientes',
        path: '/',
        meta: {
          title: 'Tablero de Expedientes',
          auth,
          scopes,
        },
        component: Default,
      },
      {
        name: 'tableroExpedientesDetalle',
        path: ':idContrato',
        meta: {
          title: 'Detalle de Expediente',
          auth,
          scopes,
        },
        component: DefaultDetalle,
      },
    ],
  },
];

export default tableroExpedientes;
